export default class UniqueManager {
    loadIndex = -1

    activeIndex = -1

    keys:{
      [key:string]: {
        forceUpdate: Function,
        isThemeRoute?: boolean,
      }
    }= {}

    reset() {
      this.loadIndex = -1;
      this.activeIndex = -1;
      this.keys = {};
    }

    initUniqueId() {
      return ++this.loadIndex;
    }

    addUniqueId(uniqueId:number, forceUpdate:Function, isThemeRoute?: boolean) {
      this.keys[uniqueId] = {
        forceUpdate,
        isThemeRoute,
      };
      if (!this.keys[this.activeIndex]) {
        this.activeIndex = uniqueId;
      } else {
        const _active = this.keys[this.activeIndex];
        if (_active.isThemeRoute) {
          this.activeIndex = uniqueId;
          _active.forceUpdate?.();
        }
      }
    }

    removeUniqueId(uniqueId:number) {
      delete this.keys[uniqueId];
      if (this.activeIndex === uniqueId) {
        let activeKey = Object.keys(this.keys).find((key) => {
          if (this.keys[key] && !this.keys[key].isThemeRoute) {
            this.activeIndex = Number(key);
            return true;
          }
          return false;
        });
        if (!activeKey) {
          activeKey = Object.keys(this.keys).find((key) => {
            this.activeIndex = Number(key);
            return this.keys[key];
          });
        }
        if (activeKey) {
          this.keys[activeKey]?.forceUpdate?.();
        } else {
          this.reset();
        }
      }
    }
}
